import { useNavigate } from 'react-router-dom';
import '../styles/selectpay.css';

const SelectPaymentMethod = () => {
  const navigate = useNavigate();

  return (
    <div className="select-payment-container">
      <div className="select-fund-card">
        <h3>Select Payment Method</h3>
        <div className="payment-options">
          <button
            className="select-wallet-btn virtual-btn"
            onClick={() => navigate("/virtual-pay")}
          >
            Pay via Virtual Account
          </button>

          <button
            className="select-wallet-btn paystack-btn"
            onClick={() => navigate("/paystack-pay")}
          >
            Pay via Paystack
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectPaymentMethod;
